import {Pipe, PipeTransform} from '@angular/core';
import {LinesDto} from '../../../Models/Purchases/Shared/line.interface';

@Pipe({
  name: 'providerProducts',
  standalone: false
})
export class ProviderProductsPipe implements PipeTransform {

  transform(items: LinesDto[], filter: { favorite: boolean, family: number }): LinesDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.favorite) {
      items = items.filter((item) => item.favorito);
    }

    if (filter.family) {
      items = items.filter((item) => item.id_familia === filter.family);
    }

    return items;

  }

}
